/* eslint-disable @typescript-eslint/no-require-imports */
import _ from 'lodash';

// DEPRECATED: add constants to lib/constants.js

function getVars() {
  // these will all be accessible from client!
  const whitelistedEnvVars = [
    'STRIPE_KEY',
    'NODE_ENV',
    'REMOTASKS_FRONTEND_URL',
    'REMOTASKS_FRONTEND_PROD_URL',
    'CRUISE_CONTROL_FRONTEND_URL',
    'CRUISE_CONTROL_FRONTEND_PROD_URL',
    'OUTLIER_FRONTEND_URL',
    'SCALE_FRONTEND_URL',
    'SCALE_FRONTEND_PROD_URL',
    'SCALE_DASHBOARD_FRONTEND_URL',
    'SCALE_DASHBOARD_FRONTEND_PROD_URL',
    'SEGMENT_KEY_SCALERS',
    'SEGMENT_KEY_CUSTOMERS',
    'SEGMENT_KEY_CORP',
    'DOMAIN',
    'FACEBOOK_OAUTH_CLIENT_ID',
    'RECAPTCHA_SITE_KEY',

    'EXTREME_POINTS_CONFIG',
  ];
  const config = {};
  for (const val of whitelistedEnvVars) {
    config[val] = process.env[val];
  }
  return config;
}

function getConfig() {
  if (typeof window !== 'undefined' && 'config' in window) {
    return ConfigSingletonCache.getConfig();
  } else {
    return getVars();
  }
}

function getConfigValue(key) {
  return getConfig()[key];
}

// returns a config value parsed as json or an empty object. this makes it easier to have sub-configs (eventually this can be fetched from db)
function getJSONConfigValue(key) {
  try {
    return JSON.parse(getConfigValue(key));
  } catch (e) {
    return {};
  }
}

const ConfigSingletonCache = {
  getConfig() {
    if (!this.config) {
      this.config = _.cloneDeep(window.config); // clone object
    }

    return this.config;
  },
};

const config = {
  getConfig,
  getConfigValue,
  getJSONConfigValue,
};

export default config;
export { getConfig, getConfigValue, getJSONConfigValue };
